import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.664 12C19.664 8.13401 16.53 5 12.664 5C10.2709 5 8.15678 6.20099 6.89391 8.03535L8.68315 7.76248C9.22912 7.67922 9.73922 8.05432 9.82248 8.60029C9.90575 9.14626 9.53065 9.65636 8.98467 9.73962L4.79052 10.3792C4.24455 10.4625 3.73446 10.0874 3.65119 9.54144L3.01157 5.34729C2.92831 4.80132 3.3034 4.29122 3.84938 4.20796C4.39535 4.12469 4.90545 4.49979 4.98871 5.04577L5.26719 6.87181C6.89177 4.53286 9.59808 3 12.664 3C17.6345 3 21.664 7.02944 21.664 12C21.664 16.9706 17.6345 21 12.664 21C9.33144 21 6.42325 19.1882 4.86862 16.5007C4.59208 16.0227 4.75544 15.4109 5.2335 15.1344C5.71156 14.8579 6.32329 15.0212 6.59983 15.4993C7.81167 17.5942 10.0742 19 12.664 19C16.53 19 19.664 15.866 19.664 12Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.4271 8.00006C12.4271 5.26055 10.2672 3.06506 7.63362 3.06506C6.1587 3.06506 4.83525 3.75104 3.95327 4.83802L5.45486 4.74478C5.7663 4.72543 6.03445 4.96223 6.05379 5.27367C6.07313 5.58511 5.83634 5.85326 5.5249 5.8726L2.69282 6.04848C2.54263 6.0578 2.39493 6.00683 2.28246 5.90687C2.16999 5.80691 2.10204 5.66621 2.09367 5.51597L1.93595 2.68282C1.9186 2.37127 2.15711 2.10464 2.46867 2.08729C2.78023 2.06995 3.04686 2.30845 3.0642 2.62001L3.14349 4.0442C4.2272 2.7559 5.8348 1.93506 7.63362 1.93506C10.9188 1.93506 13.5571 4.66443 13.5571 8.00006C13.5571 11.3357 10.9188 14.0651 7.63362 14.0651C5.4331 14.0651 3.51983 12.8373 2.49984 11.0275C2.34664 10.7556 2.44281 10.411 2.71466 10.2578C2.9865 10.1046 3.33106 10.2008 3.48427 10.4727C4.31728 11.9507 5.86739 12.9351 7.63362 12.9351C10.2672 12.9351 12.4271 10.7396 12.4271 8.00006Z"
  />
);

export const RestoreIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Restore" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
